// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Map from "rescript/lib/es6/belt_Map.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Db$Coronate from "./Db.res.js";
import * as ReactFeather from "react-feather";
import * as Hooks$Coronate from "./Hooks.res.js";
import * as Utils$Coronate from "./Utils.res.js";
import * as Router$Coronate from "./Router.res.js";
import * as Window$Coronate from "./Window.res.js";
import * as Data_Id$Coronate from "./Data/Data_Id.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Externals$Coronate from "./Externals/Externals.res.js";
import * as HelpDialogs$Coronate from "./HelpDialogs.res.js";
import VisuallyHidden from "@reach/visually-hidden";
import * as Data_Tournament$Coronate from "./Data/Data_Tournament.res.js";

var dateSort = {
  TAG: "GetDate",
  _0: (function (x) {
      return x.date;
    })
};

var nameSort = {
  TAG: "GetString",
  _0: (function (x) {
      return x.name;
    })
};

function PageTournamentList(props) {
  var __windowDispatch = props.windowDispatch;
  var windowDispatch = __windowDispatch !== undefined ? __windowDispatch : (function (param) {
        
      });
  var match = Db$Coronate.useAllTournaments();
  var dispatch = match.dispatch;
  var tourneys = match.items;
  var match$1 = Hooks$Coronate.useSortedTable(Belt_Map.valuesToArray(tourneys), dateSort, true);
  var sortDispatch = match$1[1];
  var sorted = match$1[0];
  var match$2 = React.useState(function () {
        return "";
      });
  var setNewTourneyName = match$2[1];
  var newTourneyName = match$2[0];
  var newTourneyDialog = Hooks$Coronate.useBool(false);
  var helpDialog = Hooks$Coronate.useBool(false);
  React.useEffect((function () {
          windowDispatch({
                TAG: "SetTitle",
                _0: "Tournament list"
              });
          return (function () {
                    windowDispatch({
                          TAG: "SetTitle",
                          _0: ""
                        });
                  });
        }), [windowDispatch]);
  React.useEffect((function () {
          sortDispatch({
                TAG: "SetTable",
                _0: Belt_Map.valuesToArray(tourneys)
              });
        }), [
        tourneys,
        sortDispatch
      ]);
  var updateNewName = function ($$event) {
    setNewTourneyName($$event.currentTarget.value);
  };
  var makeTournament = function ($$event) {
    $$event.preventDefault();
    var id = Data_Id$Coronate.random();
    dispatch({
          TAG: "Set",
          _0: id,
          _1: Data_Tournament$Coronate.make(id, newTourneyName)
        });
    setNewTourneyName(function (param) {
          return "";
        });
    newTourneyDialog.setFalse();
  };
  return JsxRuntime.jsx(Window$Coronate.Body.make, {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsxs("button", {
                                    children: [
                                      JsxRuntime.jsx(ReactFeather.Plus, {}),
                                      " Add tournament"
                                    ],
                                    onClick: (function (param) {
                                        newTourneyDialog.setTrue();
                                      })
                                  }),
                              JsxRuntime.jsxs("button", {
                                    children: [
                                      JsxRuntime.jsx(ReactFeather.HelpCircle, {}),
                                      JsxRuntime.jsx(VisuallyHidden, {
                                            children: " Tournament information"
                                          })
                                    ],
                                    className: "button-ghost",
                                    onClick: (function (param) {
                                        helpDialog.setTrue();
                                      })
                                  })
                            ],
                            className: "toolbar"
                          }),
                      JsxRuntime.jsx(HelpDialogs$Coronate.SwissTournament.make, {
                            state: helpDialog,
                            ariaLabel: "Tournament information"
                          }),
                      Belt_Map.isEmpty(tourneys) ? JsxRuntime.jsx("p", {
                              children: "No tournaments are added yet."
                            }) : JsxRuntime.jsxs("table", {
                              children: [
                                JsxRuntime.jsx("caption", {
                                      children: "Tournament list"
                                    }),
                                JsxRuntime.jsx("thead", {
                                      children: JsxRuntime.jsxs("tr", {
                                            children: [
                                              JsxRuntime.jsx("th", {
                                                    children: JsxRuntime.jsx(Hooks$Coronate.SortButton.make, {
                                                          children: "Name",
                                                          sortColumn: nameSort,
                                                          data: sorted,
                                                          dispatch: sortDispatch
                                                        })
                                                  }),
                                              JsxRuntime.jsx("th", {
                                                    children: JsxRuntime.jsx(Hooks$Coronate.SortButton.make, {
                                                          children: "Date",
                                                          sortColumn: dateSort,
                                                          data: sorted,
                                                          dispatch: sortDispatch
                                                        })
                                                  }),
                                              JsxRuntime.jsx("th", {
                                                    children: JsxRuntime.jsx(VisuallyHidden, {
                                                          children: "Controls"
                                                        })
                                                  })
                                            ]
                                          })
                                    }),
                                JsxRuntime.jsx("tbody", {
                                      children: Belt_Array.map(sorted.table, (function (param) {
                                              var name = param.name;
                                              var id = param.id;
                                              return JsxRuntime.jsxs("tr", {
                                                          children: [
                                                            JsxRuntime.jsx("td", {
                                                                  children: JsxRuntime.jsx(Router$Coronate.Link.make, {
                                                                        children: name,
                                                                        to_: {
                                                                          TAG: "Tournament",
                                                                          _0: id,
                                                                          _1: "Players"
                                                                        }
                                                                      })
                                                                }),
                                                            JsxRuntime.jsx("td", {
                                                                  children: JsxRuntime.jsx(Utils$Coronate.DateFormat.make, {
                                                                        date: param.date
                                                                      })
                                                                }),
                                                            JsxRuntime.jsx("td", {
                                                                  children: JsxRuntime.jsx("button", {
                                                                        children: JsxRuntime.jsx(ReactFeather.Trash2, {}),
                                                                        "aria-label": "Delete “" + name + "”",
                                                                        className: "danger button-ghost",
                                                                        title: "Delete " + name,
                                                                        onClick: (function (param) {
                                                                            var message = "Are you sure you want to delete “" + name + "”?";
                                                                            if (window.confirm(message)) {
                                                                              return dispatch({
                                                                                          TAG: "Del",
                                                                                          _0: id
                                                                                        });
                                                                            }
                                                                            
                                                                          })
                                                                      })
                                                                })
                                                          ]
                                                        }, Data_Id$Coronate.toString(id));
                                            })),
                                      className: "content"
                                    })
                              ]
                            }),
                      JsxRuntime.jsxs(Externals$Coronate.Dialog.make, {
                            isOpen: newTourneyDialog.state,
                            onDismiss: newTourneyDialog.setFalse,
                            ariaLabel: "Create new tournament",
                            children: [
                              JsxRuntime.jsx("button", {
                                    children: "Close",
                                    className: "button-micro",
                                    onClick: (function (param) {
                                        newTourneyDialog.setFalse();
                                      })
                                  }),
                              JsxRuntime.jsx("form", {
                                    children: JsxRuntime.jsxs("fieldset", {
                                          children: [
                                            JsxRuntime.jsx("legend", {
                                                  children: "Make a new tournament"
                                                }),
                                            JsxRuntime.jsxs("p", {
                                                  children: [
                                                    JsxRuntime.jsx("label", {
                                                          children: "Name:",
                                                          htmlFor: "tourney-name"
                                                        }),
                                                    JsxRuntime.jsx("input", {
                                                          id: "tourney-name",
                                                          name: "tourney-name",
                                                          placeholder: "tournament name",
                                                          required: true,
                                                          type: "text",
                                                          value: newTourneyName,
                                                          onChange: updateNewName
                                                        })
                                                  ]
                                                }),
                                            JsxRuntime.jsx("p", {
                                                  children: JsxRuntime.jsx("input", {
                                                        className: "button-primary",
                                                        type: "submit",
                                                        value: "Create"
                                                      })
                                                })
                                          ]
                                        }),
                                    onSubmit: makeTournament
                                  })
                            ],
                            className: ""
                          })
                    ],
                    className: "content-area"
                  }),
              windowDispatch: windowDispatch
            });
}

var make = PageTournamentList;

export {
  make ,
}
/* react Not a pure module */
